<template>
  <v-dialog v-model="dialogState" max-width="800" persistent>
    <v-card>
      <v-toolbar
        color="primary"
        flat
        short
      >
        <v-toolbar-title>Product</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="hideDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="3" v-for="(item, index) in items" :key="index">
              <v-card class="selector-item" @click="selectItem(item)">
                <img
                  :src="item.selector_icon_url"
                />
                <v-card-title class="justify-center">{{ item.name }}</v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="px-10 pb-10">
        <v-spacer></v-spacer>
        <v-btn v-if="categoryId" color="default" @click="selectItem()">Terug</v-btn>
        <v-btn color="default" @click="hideDialog">Annuleren</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      dialogState: false,

      categoryId: null,

    }
  },
  computed: {
    ...mapGetters('product', ['selectorItems', 'productItems']),
    items() {
      return this.categoryId ? this.productItems(this.categoryId) : this.selectorItems
    },
  },
  created() {

    Promise.all([
      this.$store.dispatch('product/fetchCategories'),
      this.$store.dispatch('product/fetchProducts'),
    ])

  },
  methods: {
    selectItem(item = null) {
      if (!item) {
        this.categoryId = null
      } else if (item.type == 'category') {
        this.categoryId = item.id
      } else if (item.type == 'product') {
        this.createItem(item)
      }
    },
    createItem(product) {
      this.$emit('update', product)
      this.hideDialog()
    },
    showDialog() {
      this.dialogState = true
    },
    hideDialog() {
      this.selectItem()
      this.dialogState = false
    },
  }
}
</script>


<style scoped>
</style>